import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  ImpactCo2Answer,
  OfficeSuppliesNewType,
  OfficeSuppliesNewValues,
  Source,
  SourceValues,
  ValuesOfficeSuppliesNew,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionOfficeSuppliesNewDto } from './dto.type';

export class QuestionOfficeSuppliesNewMapper {
  static dtoToEntity(
    dto: QuestionOfficeSuppliesNewDto,
  ): ImpactCo2Answer<ValuesOfficeSuppliesNew> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'OFFICE_SUPPLIES_NEW',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        officeSuppliesNewType: validateValueInType<OfficeSuppliesNewType>(
          dto.officeSuppliesNewType,
          OfficeSuppliesNewValues,
        ),
        count: Number.parseFloat(dto.count.toString()),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesOfficeSuppliesNew>,
    projectId: number,
  ): Omit<
    QuestionOfficeSuppliesNewDto,
    'id' | 'userId' | 'score' | 'isExternal'
  > {
    return {
      projectId: projectId,
      sector: answer.sector,
      officeSuppliesNewType: answer.values.officeSuppliesNewType,
      count: answer.values.count,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
